import React from "react";
import { TableCell, Typography } from "@material-ui/core";
import {
  DPEmployeeDisbursement,
  disbursementReasonDictionary,
  DisbursementStatus,
  disbursementStatusDictionary,
} from "Shared/types/Disbursements";
import pretty from "Shared/pretty";
import { DPLineThroughTableRow } from "Components/DP";
import DisbursementActions from "./DisbursementActions/DisbursementActions";

export interface DisbursementTableRowProps {
  disbursement: DPEmployeeDisbursement;
  showDisbursmentActionColumn: boolean;
  onAlreadyReviewed: () => void;
}

const EmployeeDisbursementTableRow = ({
  disbursement,
  showDisbursmentActionColumn,
  onAlreadyReviewed,
}: DisbursementTableRowProps) => {
  const {
    id,
    reason,
    totalAmountCents,
    userBankAccount,
    createdAt,
    disbursementReceivedOn,
    notes,
    status,
    canApprove,
  } = disbursement;
  const isRejected = status === DisbursementStatus.rejected;

  return (
    <DPLineThroughTableRow lineThrough={isRejected}>
      <TableCell>
        <Typography>{pretty.date(createdAt)}</Typography>
        <Typography noWrap>
          {pretty.date(createdAt, { format: "h:mm:ss a" })}
        </Typography>
      </TableCell>
      <TableCell>
        {disbursementReceivedOn &&
          pretty.date(disbursementReceivedOn, { utc: true })}
      </TableCell>
      <TableCell>
        {userBankAccount.name} {pretty.account(userBankAccount.accountNumber)}
      </TableCell>
      <TableCell>{pretty.dollar(totalAmountCents)}</TableCell>
      <TableCell>{disbursementReasonDictionary[reason]}</TableCell>
      <TableCell>{notes}</TableCell>
      <TableCell>
        {disbursementStatusDictionary[status as DisbursementStatus]}
      </TableCell>
      {showDisbursmentActionColumn && (
        <TableCell align="center">
          {canApprove && (
            <DisbursementActions
              onAlreadyReviewed={onAlreadyReviewed}
              disbursementId={id}
              totalAmountCents={totalAmountCents}
            />
          )}
        </TableCell>
      )}
    </DPLineThroughTableRow>
  );
};

export default EmployeeDisbursementTableRow;
